import PropTypes from 'prop-types';
import React from 'react';
import { formatRespondBy } from '../api/holdChallengesApi';
import '../styles/holdChallenges.css';

const HoldChallengeSummary = ({ challenges }) => {
  if (!challenges || challenges.length === 0) return null;

  return (
    <div className='hold-challenge-summary'>
      {challenges.map((challenge) => (
        <div key={`${challenge.role}-${challenge.id}`} className='hold-challenge-summary-row'>
          <div className='setlist-text-xs setlist-font-semibold'>
            <i className={`fas fa-bolt mr-1 ${challenge.overdue ? 'hold-challenge-overdue' : 'hold-challenge-open'}`}></i>
            {challenge.role === 'challenger' ? 'Challenging' : 'Challenged by'}
            {` H${challenge.other_position}`}
            {challenge.other_title ? ` · ${challenge.other_title}` : ''}
          </div>
          <div className={`setlist-text-xs ${challenge.overdue ? 'hold-challenge-overdue' : ''}`}>
            {challenge.overdue ? 'Overdue since ' : 'Respond by '}
            {formatRespondBy(challenge.respond_by)}
          </div>
        </div>
      ))}
    </div>
  );
};

HoldChallengeSummary.propTypes = {
  challenges: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    role: PropTypes.oneOf(['challenger', 'challenged']).isRequired,
    respond_by: PropTypes.string,
    overdue: PropTypes.bool,
    other_position: PropTypes.number,
    other_title: PropTypes.string
  }))
};

export default HoldChallengeSummary;
